import React, { useContext } from 'react';
import useHolidayService from '../../../app/services/hooks/useHolidayService';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    productId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const HolidaySwitchChange = ({ productId, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeHoliday, fetchingActiveHoliday } = useHolidayService();

    const active = (value: boolean) => {
        setChecked(value);

        activeHoliday(productId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={productId} callback={active} />;
};

export default HolidaySwitchChange;
